module.exports = __webpack_public_path__ + "static/img/yaxinanna.5e6ce4a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img/yaxinanna.png
// module id = yDyL
// module chunks = 1